import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { LanguageService } from './shared/services/language.service';
import { SseNotificationService } from './shared/services/sse-notification.service';
import { DashboardLayoutComponent } from './modules/layout';
import { AuthService } from './modules/auth/services';
import { AppFooterComponent } from '@app/shared/components/app-footer/app-footer.component';
import { combineLatest } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, FormsModule, CommonModule, ReactiveFormsModule, FloatLabelModule, InputTextModule, ToastModule, DashboardLayoutComponent, AppFooterComponent],
})
export class AppComponent {
  title = 'frontend';
  isLoggedIn = false;

  private readonly _destroyRef = inject(DestroyRef);
  private readonly _sseNotification = inject(SseNotificationService);

  constructor(private _languageService: LanguageService, private _authService: AuthService, private router: Router) {
    this._sseNotification.init();
    const isOnAuthRoute$ = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map(event => event.urlAfterRedirects.startsWith('/auth')),
      startWith(this.router.url.startsWith('/auth'))
    );

    combineLatest([this._authService.currentUser$, isOnAuthRoute$]).pipe(
      takeUntilDestroyed(this._destroyRef)
    ).subscribe(
      ([currentUser, isOnAuthRoute]) => {
        this.isLoggedIn = !!currentUser && !isOnAuthRoute;
      }
    );
  }

  toggleDarkMode() {
      document.documentElement.classList.toggle('app-dark');
  }
}
